export default __webpack_public_path__ + "static/media/illustrator.be2c11a3.png";